import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService, HelperService } from 'app/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { findIndex } from 'lodash';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TemplatesComponent implements OnInit, OnDestroy {
  unsubscribe: Subject<boolean> = new Subject<boolean>();
  navItems: any = [
    {
      id: 'appointment-t',
      label: 'Appointments',
      link: 'appointment/confirmation',
      icon: 'fal fa-comment-alt-check',
      items: [
        {
          id: 'confirmation-t',
          label: 'New',
          link: 'appointment/confirmation',
          icon: '',
        },
        {
          id: 'reminder-t',
          label: 'Reminder',
          link: 'appointment/reminder',
          icon: '',
        },
        {
          id: 'reply-confirm-t',
          label: 'Appointment confirmed',
          link: 'appointment/reply-confirm',
          icon: '',
        },
        {
          id: 'reply-cancel-t',
          label: 'Appointment canceled',
          link: 'appointment/reply-cancel',
          icon: '',
        },
        {
          id: 'reschedule-t',
          label: 'Rescheduled',
          link: 'appointment/reschedule',
          icon: '',
        },
        {
          id: 'cancel-t',
          label: 'Deleted by Shop',
          link: 'appointment/cancellation',
          icon: '',
        },
      ],
    },
    {
      id: 'auth-t',
      label: 'Authentication',
      link: 'authentication/set-password',
      icon: 'fal fa-unlock-alt',
      items: [
        {
          id: 'set-password-t',
          label: 'Set Password',
          link: 'authentication/set-password',
          icon: '',
        },
        {
          id: 'reset-password-t',
          label: 'Reset Password',
          link: 'authentication/reset-password',
          icon: '',
        },
        {
          id: 'welcome-t',
          label: 'Welcome',
          link: 'authentication/welcome',
          icon: '',
        },
      ],
    },
    {
      id: 'order-t',
      label: 'Order',
      link: 'order/estimation',
      icon: 'fal fa-shopping-cart',
      items: [
        {
          id: 'inspection-t',
          label: 'Inspection',
          link: 'order/inspection',
          icon: '',
        },
        {
          id: 'estimation-t',
          label: 'Estimate',
          link: 'order/estimation',
          icon: '',
        },
        {
          id: 'estimation-deposit-t',
          label: 'Estimate deposit',
          link: 'order/estimate-deposit',
          icon: '',
        },
        {
          id: 'estimation-deposit-r',
          label: 'Estimate deposit reminder',
          link: 'order/estimate-deposit-reminder',
          icon: '',
        },
        {
          id: 'estimate-approval-r',
          label: 'Estimate approval reminder',
          link: 'order/estimate-approval-reminder',
          icon: '',
        },
        { id: 'invoice-t', label: 'Invoice', link: 'order/invoice', icon: '' },
        {
          id: 'invoice-vehicle-pickup',
          label: 'Invoice with Vehicle pickup',
          link: 'order/invoice-vehicle-pickup',
          icon: '',
        },
        { id: 'receipt-t', label: 'Receipt', link: 'order/receipt', icon: '' },
        {
          id: 'review-receipt-t',
          label: 'Receipt & Review - Internal',
          link: 'order/review-receipt',
          icon: '',
        },
        {
          id: 'review-receipt-google-t',
          label: 'Receipt & Review - Google',
          link: 'order/review-receipt-google',
          icon: '',
        },
        {
          id: 'inv-disclaimer-t',
          label: 'Invoice Disclaimer',
          link: 'order/inv-disclaimer',
          icon: '',
        },
        {
          id: 'disclaimer-t',
          label: 'Estimate Disclaimer',
          link: 'order/disclaimer',
          icon: '',
        },
        {
          id: 'pdf-logo-t',
          label: 'PDF Logo',
          link: 'order/pdf-logo',
          icon: '',
        },
      ],
    },
    {
      id: 'review-t',
      label: 'Reviews',
      link: 'reviews/review-request',
      icon: 'fal fa-comments-alt',
      items: [
        {
          id: 'review-request-t',
          label: 'Review Request - Internal',
          link: 'reviews/review-request',
          icon: '',
        },
        {
          id: 'review-reminder-t',
          label: 'Review Reminder - Internal',
          link: 'reviews/review-reminder',
          icon: '',
        },
        {
          id: 'google-review-t',
          label: 'Google review request',
          link: 'reviews/google-review',
          icon: '',
        },
        {
          id: 'review-request-google-t',
          label: 'Review Request - Google',
          link: 'reviews/review-request-google',
          icon: '',
        },
        {
          id: 'review-reminder-google-t',
          label: 'Review Reminder - Google',
          link: 'reviews/review-reminder-google',
          icon: '',
        }
      ],
    },
    {
      id: 'fleet-t',
      label: 'Fleet',
      link: 'fleet/statement',
      icon: 'fal fa-file-invoice',
      items: [
        {
          id: 'statement-t',
          label: 'Statement',
          link: 'fleet/statement',
          icon: '',
        },
        {
          id: 'bulk-payment-t',
          label: 'Bulk payment receipt',
          link: 'fleet/bulk-payment',
          icon: '',
        },
      ],
    },
    {
      id: 'oil-change-t',
      label: 'Oil change sticker',
      link: 'oil-change',
      icon: 'fal fa-oil-can',
    },
    {
      id: 'business-summary-report',
      label: 'Business summary report',
      link: 'business-summary-template',
      icon: 'fal fa-file-chart-line',
    },
  ];
  role = '';
  isApptRequestPortalEnabled = false;
  isPartWarrantiesEnabled: boolean = false;
  isTireWarrantyPolicyEnabled: boolean = false;
  isMidasRoyaltyReportsEnable: boolean = false;

  constructor(private helperService: HelperService, private dataService: DataService) {}

  ngOnInit() {
    this.role = this.helperService.getCompany().role;
    this.isApptRequestPortalEnabled = this.dataService.isApptRequestPortalEnabled;
    this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
    this.isTireWarrantyPolicyEnabled = this.dataService.isTireWarrantyPolicyEnabled;
    this.isMidasRoyaltyReportsEnable = this.dataService.isMidasRoyaltyReportsEnable;

    if (this.role == 'super') {
      let role = {
        id: 'marketing-t',
        label: 'Marketing',
        link: 'marketing/MARKETING_ANN',
        icon: 'fal fa-file-invoice',
        items: [
          {
            id: 'announcement-t',
            label: 'Announcement',
            link: 'marketing/MARKETING_ANN',
            icon: '',
          },
          {
            id: 'product-t',
            label: 'Product',
            link: 'marketing/MARKETING_PRD',
            icon: '',
          },
          {
            id: 'classic-t',
            label: 'Classic',
            link: 'marketing/classic',
            icon: '',
          },
          {
            id: 'festive-t',
            label: 'Festive',
            link: 'marketing/festive',
            icon: '',
          },
          {
            id: 'modern-t',
            label: 'Modern',
            link: 'marketing/modern',
            icon: '',
          },
          {
            id: 'newsletter-t',
            label: 'Newsletter',
            link: 'marketing/newsletter',
            icon: '',
          },
        ],
      };
      this.navItems.push(role);
    }
    this.enableAppointmentRequestTemplate();
    this.enableWarrantyPolicyTemplate();
    this.setListener();
  }

  setListener() {
    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((obj) => {
        const data = obj.data;
        if (data.key === 'company-appdata-updated') {
          this.isApptRequestPortalEnabled = this.dataService.isApptRequestPortalEnabled;
          this.isPartWarrantiesEnabled = this.dataService.isPartWarrantiesEnabled;
          this.isMidasRoyaltyReportsEnable = this.dataService.isMidasRoyaltyReportsEnable;

          this.enableAppointmentRequestTemplate();
          this.enableWarrantyPolicyTemplate();
        }
      });
  }

  enableWarrantyPolicyTemplate() {
    if(this.isPartWarrantiesEnabled) {
      const orderIndex = findIndex(this.navItems, {id: 'order-t'});
      if(orderIndex > -1) {
        const invDiscIndex = findIndex(this.navItems[orderIndex].items, {id: 'inv-disclaimer-t'});
        if(invDiscIndex > -1) {
          const foundIndex = findIndex(this.navItems[orderIndex].items, {id: 'warranty-disclaimer-t'});
          if(foundIndex < 0) {
            this.navItems[orderIndex].items.splice(invDiscIndex, 0, {
              id: 'warranty-disclaimer-t',
              label: 'Warranty Policy',
              link: 'order/warranty-policy',
              icon: '',
            });
            
            if(this.isTireWarrantyPolicyEnabled) {
              const wDiscIndex = findIndex(this.navItems[orderIndex].items, {id: 'warranty-disclaimer-t'});
              const foundIndexTW = findIndex(this.navItems[orderIndex].items, {id: 'tire-warranty-t'});
              if(foundIndexTW < 0) {
                this.navItems[orderIndex].items.splice(wDiscIndex + 1, 0, {
                  id: 'tire-warranty-t',
                  label: 'Tire Warranty Policy',
                  link: 'order/tire-warranty-policy',
                  icon: '',
                });
              }
            }
          }
        }
      }
    }

    if(this.isMidasRoyaltyReportsEnable) {
      this.navItems.push({
        id: 'ROYALTY_REPORT',
        label: 'Royalty Report',
        link: 'royalty-report-template',
        icon: 'fal fa-file-chart-line',
      });
    }
  }

  enableAppointmentRequestTemplate() {
    if (this.isApptRequestPortalEnabled) {
      this.navItems.map((appointment) => {
        if (appointment.id === 'appointment-t') {
          let appointmentRequestItems = [
            {
              id: 'request-receive-t',
              label: 'Request Received',
              link: 'appointment/request-received',
              icon: '',
            },
            {
              id: 'request-decline-t',
              label: 'Declined Request',
              link: 'appointment/request-declined',
              icon: '',
            },
          ];
          appointment.items.push(...appointmentRequestItems);
        }
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }
}
